import VForm from '@/vuetify_custom/v-form'
import { VBtn, VCard, VCardTitle, VCardText } from 'vuetify/lib'
import VTable from '@/vuetify_custom/v-table/v3'
import DatePicker from '@/vuetify_custom/v-date-picker_v1'
import Select from '@/vuetify_custom/v-form/components/Select_v1.js'
import NumberField from '@/vuetify_custom/v-form/components/Number_Field.js'
import TextareasField from '@/vuetify_custom/v-form/components/Textareas_Field.js'
import VPopDel from './v-pop-del'
import {AGREEMENT} from '../constants'
// Textareas_Field
import { commonValidateRule, createContractSettlementsParams, isIllegalityValue } from '../utils'
import { common_mixins } from './EditMixIns.jsx'
import styles from './index.module.less'
const commonValidateRuleGo = commonValidateRule('必选')
const commonValidateRuleGoone = commonValidateRule('必填')
export default {
    mixins:[common_mixins],
    computed: {
        is_payment_amount_1() {
            if (isIllegalityValue(this.params.total_price)) {
                return true
            }
            const total = this.params.contract_settlements.reduce((total, item) => {
                return math.eval(`${total} + ${item.payment_amount}`)
            }, 0).toFixed(2)
            const is_go = Number(total) === Number(this.params.total_price)
          
            return is_go
        },
        is_settlement_percentage_1() {
          const total = this.params.contract_settlements.reduce((total, item) => {
                return math.eval(`${total} + ${item.settlement_percentage}`)
            }, 0).toFixed(2)
            return Number(total) === 100
        },
        table_fields() {
            const _this = this
            return [
                {
                    text: '履约批次',
                    align: 'center',
                    value: 'index',
                    type: 'button_g_field',
                    width: 90,
                    fixed: 'left',
                    render: (_, __, index) => {
                        return <div>
                       <span >{index + 1}</span>
                    </div>
                    }
                },
                {
                    text: '履约时间从',
                    align: 'center',
                    value: 'start_date',
                    width: 150,
                    required:true,
                    render: (_, __, index) => {
                        return <DatePicker
                            required
                            v-model={_this.params.contract_settlements[index].start_date}
                            allowed-dates={(val) => {
                                const end_date = _this.params.contract_settlements[index].end_date
                                if (end_date < val) {
                                    return false
                                }
                                return true
                            }}
                            rules={[commonValidateRuleGo]}
                        />
                    }
                },
                {
                    text: '履约时间到',
                    align: 'center',
                    value: 'uid',
                    width: 150,
                    required:true,
                    render: (_, __, index) => {

                        return <DatePicker
                            required
                            allowed-dates={(val) => {
                                const start_date = _this.params.contract_settlements[index].start_date
                                if (start_date > val) {
                                    return false
                                }
                                return true
                            }}
                            v-model={_this.params.contract_settlements[index].end_date}
                            rules={[commonValidateRuleGo]}
                        />
                    }
                },
                {
                    text: '结算方式',
                    align: 'center',
                    value: 'uid',
                    width: 200,
                    render: (_, __, index) => {
                        
                        return <Select
                            v-model={_this.params.contract_settlements[index]}
                            field = {{
                                    required:true,
                                    key: 'settlement_type',
                                    disabled: index !== 0,
                                    items: [
                                        {
                                            title: '按约定比例',
                                            key: AGREEMENT,
                                        },
                                        {
                                            title: '按月',
                                            key: 'per_month',
                                        },
                                        {
                                            title: '按次',
                                            key: 'per_time',
                                        }
                                    ],
                                    rules:[commonValidateRuleGo],
                                    change: (val) => {
                                        _this.params.contract_settlements.forEach(item => {
                                            item.settlement_type = val
                                        });
                                    }
                                }}
                        />
                    }
                },
                {
                    text: '结算比例',
                    align: 'center',
                    value: 'uid',
                    width: 120,
                    render: (_, __, index) => {
                        //  NumberField
                        if (__.settlement_type !== 'agreement') {
                            return '-'
                        }
                        return <NumberField
                            v-model={_this.params.contract_settlements[index]}
                            field = {{
                                    required:true,
                                    key: 'settlement_percentage',
                                    rules:[commonValidateRuleGoone, (val) => {
                                        if (Number(val) < 0) {
                                            return '比例不能小于0'
                                        }
                                        if (!_this.is_settlement_percentage_1) {
                                            return '结算比例之和需要等于100%'
                                        }
                                        return true
                                    }],
                                    suffix: '%'
                                }}
                        /> 
                    }
                },
                {
                    text: '约定付款金额',
                    align: 'center',
                    width: 160,
                    render: (_, __, index) => {
                        //  NumberField
                        
                        return <NumberField
                             v-model={_this.params.contract_settlements[index]}
                            field = {{
                                    required:true,
                                    key: 'payment_amount',
                                    rules:[commonValidateRuleGoone, (val) => {
                                        if (Number(val) < 0) {
                                            return '比例不能小于0'
                                        }
                                        if (!_this.is_payment_amount_1) {
                                            return '约定付款金额之和需要和合同金额[预估金额]相等'
                                        }
                                        return true
                                    }],
                                    input() {
                                        setTimeout(() => {
                                            if (_this.is_payment_amount_1) {
                                                _this.validate()
                                            }
                                        }, 200)
                                    }
                                }}
                        /> 
                    }
                },
                {
                    text: '约定付款时间',
                    align: 'center',
                    value: 'payment_date',
                    width: 150,
                    render: (_, __, index) => {

                        return <DatePicker
                            required
                            v-model={_this.params.contract_settlements[index].payment_date}
                            rules={[commonValidateRuleGo]}
                        />
                    }
                },
                {
                    text: '备注',
                    align: 'center',
                    value: 'uid',
                    width: 200,
                    render: (_, __, index) => {

                    return <TextareasField
                    v-model={_this.params.contract_settlements[index]}
                        field = {{
                                key: 'desc',
                                rows:1,
                            }}
                    /> 
                    }
                },
                {
                    text: '操作',
                    align: 'center',
                    type: 'button_g_field',
                    // value: 'uid',
                     width: 120,
                     fixed: 'right',
                    render: (_, __, index) => {
                        if (_this.params.contract_settlements.length <= 1) {
                            return ''
                        }
                        return <VPopDel
                        title="确定删除该条数据？"
                        on={{
                            submit:() => {
                                _this.params.contract_settlements.splice(index, 1)
                            }
                        }}
                    />
                    }
                }
            ]
        },
        contract_types_filter() {
          // const {main_type} = this.params
            return this.contract_types
        },
        fields() {
            return [
                {
                    key:'table',
                    cols: 12,
                },
            ]
        }
    },
    render() {
        const _this = this
        return <div class={styles['block-margin']}>
        <VCard flat light outlined>
            <VCardTitle>
                合同结算款项
                <VBtn class={styles['btn-f']} 
                    outlined
                    color="primary"
                    small
                    on={{
                        click:() => {
                            const item = createContractSettlementsParams()
                            _this.params.contract_settlements.push(item)
                            item.settlement_type = _this.params.contract_settlements[0].settlement_type
                        }
                    }}
                    >
                    添加结算行
                </VBtn>
                <span class={styles['contract-clearing-bank']}>若约定付款时间无法确定，请根据条款预估（不影响后续任何流程）</span>
            </VCardTitle>
            <VCardText>
            <VForm
                ref="base"
                fields={_this.fields}
                scopedSlots={{
                    table:() => {
                        return <VTable
                            headers={this.table_fields}
                            desserts={this.params.contract_settlements}
                        />
                    }
                }}
            />
            </VCardText>
        </VCard>
    </div>
    }
}   